import { useEffect } from "react";
import { Step } from "../components/forms/FormBondApp.constants";

export const useScroll = (
  elementRef: React.RefObject<HTMLDivElement>,
  step: Step,
  isDisable: boolean
) => {
  const header = document.querySelector(".navbar");
  const headerTopOffset = header?.getBoundingClientRect()?.top;

  useEffect(() => {
    if (!elementRef.current || typeof window !== "object" || isDisable) {
      return;
    }

    const formTitlePosition = Number(
      elementRef.current.getBoundingClientRect()?.top
    );

    window.scrollTo({
      top: formTitlePosition - (headerTopOffset || 0) + window.pageYOffset,
      behavior: "smooth",
    });
  }, [elementRef, isDisable, step]);
};
